import { BasicProductDataResponse } from '@/src/types/catalog';
import { OrderType } from '@/src/types/stores';

export enum HomeScreenSectionTypeEnum {
  PromotedStore = 1,
  PromotedStores = 2,
  PromotedProducts = 3,
  PromotedProduct = 4,
  Slider = 5,
  OneImage = 6,
  TwoImages = 7,
  ThreeImages = 8,
  FourImages = 9,
  NearbyList = 10,
  TrendingStores = 11,
  TrendingProducts = 12,
  DigitalCard = 13,
  HeroBanner = 14,
  PromoBanner = 15,
  Department = 16,
  Industry = 17,
  SubIndustry = 18,
  AllProducts = 19,
  Grid = 20,
}

export type ICmsTheme = {
  backgroundImage: string | null;
  backgroundColor: string | null;
} | null;

export interface ICmsSection {
  id: number;
  name: string;
  description: string;
  content: any;
  sectionsType: HomeScreenSectionTypeEnum;
  showSectionTitle: boolean;
  showSectionDescription: boolean;
  index: number;
  theme: ICmsTheme;
}

export interface IStoreTheme {
  Color: string;
  Image: string;
}

export enum DestinationTypes {
  PRODUCT = 1,
  LIST_OF_PRODUCTS = 2,
  STORE = 3,
  LIST_OF_BRANCHES = 4,
  INDUSTRY = 5,
  IN_APP_NAVIGATION = 6,
  NO_DESTINATION = 7,
  EXTERNAL_URL = 8,
  PAGE = 9,
}

export interface IDestination {
  DestinationType: DestinationTypes;
  DestinationValue: string[] | string;
  ArabicDestinationHeader: string;
  EnglishDestinationHeader: string;
}

///////// PromotedStore = 1 /////////

export interface IPromotedStore {
  StoreId: string;
  BranchId: string;
  BranchName: string;
  StoreName: string;
  ArabicStoreName: string;
  EnglishStoreName: string;
  StoreLogoUrl: string;
  Theme: IStoreTheme | null;
  Products: BasicProductDataResponse[];
}

//////// PromotedStores = 2 , TrendingStores = 11 , NearbyList = 10 ///////

export interface ICmsBranch {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  store: ICmsStore;
  distance: number;
  orderTypes: number[];
}

export interface ICmsStore {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  logoURL: string;
  theme: IStoreTheme | null;
}

/////////// PromotedProducts = 3 , PromotedProduct = 4  //////////////
export interface IPromotedProduct {
  storeLogoUrl: string;
  id: number;
  integrationId: string;
  arabicName: string;
  englishName: string;
  price: number;
  originalPrice: number;
  isSoldOut: boolean;
  defaultImage: string;
  isHaveValidDiscount: boolean;
  discount: number | null;
  branchId: string;
  storeName: string | null;
  storeEnglishName: string;
  storeArabicName: string;
  storeLogUrl: string;
  branchName: string | null;
  storeId: string;
  currency: string;
}

/////// Slider = 5 ,  oneImage = 6 , twoImages = 7 , threeImages = 8 , FourImages = 9 /////////
export enum MediaType {
  Image = 1,
  Video = 2,
}

export interface IBanner {
  Id: string;
  ArabicVideo: string | null;
  EnglishVideo: string | null;
  MediaType: MediaType;
  ArabicImage: string;
  EnglishImage: string;
  Destination: IDestination;
}

////////// DigitalCard = 13 ///////////
export interface IDigitalCard {
  integrationId: string;
  arabicName: string;
  englishName: string;
  defaultImage: string;
  price: number;
  discount: Discount;
  isHaveValidDiscount: boolean;
  isSoldOut: boolean;
  originalPrice: number;
  isExternalProduct: boolean;
  externalUrl: string;
  branchId: string;
  countryId: string;
  currencyCode: string;
}

interface Discount {
  id: number;
  productIntegrationId: string;
  arabicName: string;
  englishName: string;
  discountType: number;
  discountStatus: number;
  discountValue: number;
  startOn: string;
  endOn: string;
  limitQuantity: number;
  limitPerUser: number;
}

//////////  HeroBanner = 14 /////////

export interface IHeroBanner {
  Id: string;
  HeaderColor: string;
  Index: number;
  ArabicImage: string;
  EnglishImage: string;
  Destination: IDestination;
}

/////// PromotedBanner = 15 /////////

export interface IPromotedBanner {
  ArabicImage: string;
  EnglishImage: string;
  Destination: IDestination;
}

/////// Grid = 20 /////////

export interface IDepartment {
  Id: number;
  ArabicName: string;
  EnglishName: string;
  ArabicImage: string;
  EnglishImage: string;
  Destination: IDestination;
}

export interface Product {
  integrationId: string;
  arabicName: string;
  englishName: string;
  arabicDescription: string;
  englishDescription: string;
  price: number;
  originalPrice: number;
  tax: number;
  taxType: number;
  isSoldOut: boolean;
  returnable: boolean;
  defaultImage: string;
  isHaveValidDiscount: boolean;
  discount: Discount | null;
  branchId: string;
  storeName: string | null;
  branchName: string | null;
  storeId: string;
  tagsIds: any[] | null; // Assuming this is an array of tag objects or IDs
}

export interface ICountryResponse {
  id: string;
  arabicCountryName: string;
  englishCountryName: string;
  currencyCode: string;
}

export interface DestinationStoreRequest {
  value: string;
}

export interface DestinationStoresRequest {
  value: string[];
}

export interface DestinationProductsRequest {
  value: (string | number)[];
  branchId?: number;
}

export interface DestinationProductRequest {
  value: string;
}

export interface ProductDetailsRequest {
  branchId: string;
  productId: string;
  storeName: string;
  storeNameArabic: string;
  storeNameEnglish: string;
  productNameArabic: string;
  productNameEnglish: string;
}

export interface BranchRequest {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  store: ICmsStore;
  distance: number;
  orderTypes: number[];
  currency: string;
}
